import React, { useEffect, useState } from "react";
import {
  Box,
  Card,
  Typography,
  TextField,
  Button,
  useTheme,
  InputAdornment,
  IconButton,
  Divider,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import ArrowBackIosNewOutlined from "@mui/icons-material/ArrowBackIosNewOutlined";
import { useNavigate } from "react-router-dom";
import useIPAddress from "../Utils/useIPAddress";
import axios from "axios";
import { baseapi } from "../Environmentalurl";
import {
  ApplicationType,
  entity_id,
  getGeolocation,
  location,
  Platform,
} from "../Utils/Const";
import DashboardHeader from "../Dashboard/DashboardHeader";
import api from "../Utils/Api";

export default function UpdateEmail() {
  const [open, setOpen] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [resendTimer, setResendTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);
  const [requestId, setRequestId] = useState("");
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [mobileNumber, setMobileNumber] = useState(" ");
  const ip = useIPAddress();
  const theme = useTheme();
  const isDark = theme.palette.mode === "dark";
  const navigate = useNavigate();

  // Theme-based colors
  const pageBg = isDark ? "#0B1321" : "#f2f4f7";
  const cardBg = isDark ? "#162033" : "#ffffff";
  const textColor = isDark ? "#ffffff" : "#0e1b2c";
  const subTextColor = isDark ? "#a5b1c7" : "#697386";
  const inputBg = isDark ? "#0D1729" : "#f3f5f7";
  const borderColor = isDark
    ? "1px solid rgba(90,126,173,0.40)"
    : "1px solid rgba(0,0,0,0.15)";

  const handlehomenavigation = () => navigate("/profile-settings");

  const handleClickOpen = async () => {
    if (!email || !name) {
      alert("Please enter name and email.");
      return;
    }

    setOtp(["", "", "", "", "", ""]);
    setRequestId("");
    setCanResend(false);
    setResendTimer(60);

    await sendOTP(email);
  };

  const handleClose = () => setOpen(false);

  useEffect(() => {
    let timer;
    if (resendTimer > 0) {
      timer = setTimeout(() => setResendTimer(resendTimer - 1), 1000);
    } else {
      setCanResend(true);
    }
    return () => clearTimeout(timer);
  }, [resendTimer]);

  const handleResendOTP = () => {
    setOtp(["", "", "", "", "", ""]);
    setResendTimer(60);
    setCanResend(false);
    sendOTP();
  };
  const handleVerify = async () => {
    const enteredOtp = otp.join("");

    try {
      const response = await api.post(
        `${baseapi}/JanAadhaarEmailVerification`,
        {
          Platform: Platform,
          ApplicationType: ApplicationType,
          EntityID: entity_id,
          GeoLocation: location,
          MachineID: ip,
          ReqType: "Jan_Aadhaar_Email_Verification",
          Statement: "ValidateOTP",
          EmailID: email,
          Mobilenumber: mobileNumber,
          InReqID: requestId,
          EmailOTP: enteredOtp,
        },
      );

      const data = response.data;

      if (data.Response_Code === "1000") {
        alert("Email updated successfully.");
        setOpen(false);
        // email is already in your state and text field, so no extra action is needed
      } else {
        alert("OTP verification failed: " + data.Message);
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      alert("Something went wrong during OTP verification.");
    }
  };

  const handleChange = (element, index) => {
    const newOtp = [...otp];
    newOtp[index] = element.value.slice(0, 1);
    setOtp(newOtp);
    if (element.value && index < 5) {
      const nextInput = document.getElementById(`otp-${index + 1}`);
      nextInput?.focus();
    }
  };

  useEffect(() => {
    const NameOnCard = JSON.parse(
      sessionStorage.getItem("NameOnCard") || "null",
    );
    const Poiemail = JSON.parse(sessionStorage.getItem("Poiemail") || "null");
    const mobileNumber = JSON.parse(
      sessionStorage.getItem("mobileNumber") || "null",
    );

    if (NameOnCard) setName(NameOnCard);
    if (Poiemail) setEmail(Poiemail);
    if (mobileNumber) setMobileNumber(mobileNumber);
  }, []);

  const mobilenumber = mobileNumber;
  const sendOTP = async (newEmail = email) => {
    try {
      const response = await api.post(
        `${baseapi}/JanAadhaarEmailVerification`,
        {
          Platform: Platform,
          ApplicationType: ApplicationType,
          EntityID: entity_id,
          GeoLocation: location,
          MachineID: ip,
          ReqType: "Jan_Aadhaar_Email_Verification",
          Statement: "SendOTP",
          EmailID: newEmail,
          Mobilenumber: mobileNumber,
          InReqID: "",
          EmailOTP: "",
        },
      );

      const data = response.data;

      if (data.Response_Code === "1000") {
        setRequestId(data.RequestID);
        setOpen(true);
        setResendTimer(60);
        setCanResend(false);
        console.log("OTP sent successfully");
      } else {
        alert("Failed to send OTP: " + data.Message);
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      alert("Something went wrong while sending OTP.");
    }
  };

  return (
    <>
      <DashboardHeader />
      <Box
        sx={{
          minHeight: "100vh",
          backgroundColor: pageBg,
          p: { xs: 2, md: 4 },
        }}
      >
        {/* ---------------- Header ---------------- */}

        {/* ---------------- Main Center Card ---------------- */}
        <Box
          sx={{
            mt: 5,
            display: "flex",
            justifyContent: "center",
          }}
        >
          <Card
            sx={{
              width: "100%",
              maxWidth: 450,
              backgroundColor: cardBg,
              p: 4,
              borderRadius: 3,
              border: borderColor,
              boxShadow: isDark
                ? "0px 0px 20px rgba(0,0,0,0.4)"
                : "0px 0px 10px rgba(0,0,0,0.1)",
            }}
          >
            {/* Title */}
            <Box display="flex" alignItems="center" gap={1.5} mb={4}>
              <IconButton
                onClick={handlehomenavigation}
                sx={{
                  bgcolor: "white",
                  color: "#1e5fd8",
                }}
              >
                <ArrowBackIosNewOutlined />
              </IconButton>

              <Typography
                variant="h5"
                fontWeight="700"
                sx={{ color: textColor }}
              >
                Add or Update Email
              </Typography>
            </Box>

            {/* Full Name */}
            <Typography sx={{ color: subTextColor, mb: 1, fontSize: 14 }}>
              Full Name
            </Typography>

            <TextField
              fullWidth
              placeholder="Enter Name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              sx={{
                mb: 3,
                "& .MuiOutlinedInput-root": {
                  backgroundColor: inputBg,
                  borderRadius: 2,
                  fontWeight: 600,
                  color: textColor,
                  "& fieldset": { border: "none" },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PersonOutlineOutlinedIcon sx={{ color: subTextColor }} />
                  </InputAdornment>
                ),
              }}
            />

            {/* New Email */}
            <Typography sx={{ color: subTextColor, mb: 1, fontSize: 14 }}>
              New Email Address
            </Typography>

            <TextField
              fullWidth
              placeholder="you@example.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{
                "& .MuiOutlinedInput-root": {
                  backgroundColor: inputBg,
                  borderRadius: 2,
                  fontWeight: 600,
                  color: textColor,
                  "& fieldset": { border: "none" },
                },
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <EmailOutlinedIcon sx={{ color: subTextColor }} />
                  </InputAdornment>
                ),
              }}
            />

            {/* Description text */}
            <Typography
              sx={{
                mt: 1.2,
                color: subTextColor,
                fontSize: 13,
              }}
            >
              A verification link will be sent to your new email address.
            </Typography>

            {/* Button */}
            <Button
              fullWidth
              onClick={handleClickOpen}
              sx={{
                mt: 3,
                py: 1.4,
                background: "linear-gradient(to right, #497BFF, #34E0C0)",
                color: "white",
                fontWeight: 700,
                textTransform: "none",
                borderRadius: 2,
                fontSize: 15,
                "&:hover": {
                  background: "linear-gradient(to right, #3c6ff0, #2bccae)",
                },
              }}
            >
              Verify & Update →
            </Button>
          </Card>
        </Box>
      </Box>

      <Dialog
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            borderRadius: 4,
            p: 2,
            backgroundColor: isDark ? "#0f1a2b" : "#ffffff",
            width: 420,
          },
        }}
      >
        {/* HEADER */}
        <Box textAlign="center" mb={1}>
          <Typography
            variant="h6"
            fontWeight={700}
            sx={{ color: isDark ? "#fff" : "#0e1b2c" }}
          >
            Email Verification
          </Typography>

          <Typography
            variant="body2"
            sx={{ color: isDark ? "#9aaac2" : "#5d6570", mt: 0.5 }}
          >
            Enter the 6-digit OTP sent to your email
          </Typography>
        </Box>

        <Divider sx={{ my: 2, opacity: 0.2 }} />

        {/* OTP BOXES */}
        <Box display="flex" justifyContent="center" gap={1.4} mt={1} mb={1}>
          {otp.map((digit, index) => (
            <TextField
              key={index}
              id={`otp-${index}`}
              value={digit}
              onChange={(e) => handleChange(e.target, index)}
              variant="outlined"
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: 52,
                  width: 48,
                  borderRadius: 2,
                  backgroundColor: isDark ? "#112033" : "#f3f5f7",
                  color: isDark ? "white" : "#0e1b2c",
                  fontSize: "20px",
                  fontWeight: 600,
                  "& fieldset": {
                    borderColor: isDark
                      ? "rgba(120,150,190,0.4)"
                      : "rgba(0,0,0,0.2)",
                  },
                  "&:hover fieldset": {
                    borderColor: "#3FA2F7",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#3FA2F7",
                    boxShadow: "0px 0px 6px rgba(63,162,247,0.6)",
                  },
                },
                input: { textAlign: "center" },
              }}
              inputProps={{
                maxLength: 1,
              }}
            />
          ))}
        </Box>

        {/* RESEND */}
        <Box textAlign="center" mt={2}>
          {canResend ? (
            <Button
              onClick={handleResendOTP}
              sx={{
                textTransform: "none",
                fontWeight: 600,
                color: "#3FA2F7",
                fontSize: "14px",
              }}
            >
              Resend OTP
            </Button>
          ) : (
            <Typography
              variant="body2"
              sx={{ color: isDark ? "#9aaac2" : "#5d6570" }}
            >
              Resend OTP in <b>{resendTimer}</b> seconds
            </Typography>
          )}
        </Box>

        {/* BUTTONS */}
        <Box mt={3} display="flex" justifyContent="space-between" gap={2}>
          <Button
            onClick={handleClose}
            fullWidth
            sx={{
              textTransform: "none",
              fontWeight: 600,
              color: isDark ? "#fff" : "#0e1b2c",
              backgroundColor: isDark ? "#152238" : "#e3e7ec",
              borderRadius: 2,
              py: 1.1,
              "&:hover": {
                backgroundColor: isDark ? "#1d2c44" : "#d4d9df",
              },
            }}
          >
            Cancel
          </Button>

          <Button
            onClick={handleVerify}
            fullWidth
            sx={{
              textTransform: "none",
              fontWeight: 700,
              color: "white",
              borderRadius: 2,
              py: 1.1,
              background: "linear-gradient(90deg,#4C8CFF,#3ED6B6)",
              "&:hover": {
                background: "linear-gradient(90deg,#3A76EA,#2EC6A4)",
              },
            }}
          >
            Verify OTP
          </Button>
        </Box>
      </Dialog>
    </>
  );
}
